<template lang="pug">
#dashboard
  el-row(type="flex" justify="space-between")
    el-col#visited(:span="12" v-intro="$t('Guide.dashboard_guide01')")
      h1 {{ $t('Dashboard.title01') }}
      p {{ $t('Dashboard.description01') }}
      template.graph
        p.noneVisited(v-if="!anyCountsOf.visited") {{ $t('Dashboard.none_data') }}
        Visited#visitedGraph(:height="240" v-on:counts-updated="onCountsUpdated('visited', $event)")

    el-col#today(:span="12" v-intro="$t('Guide.dashboard_guide02')")
      h1 {{ $t('Dashboard.title02') }}
      p {{ $t('Dashboard.description02') }}
      el-row.graph
        el-col.graph(:span="12")
          h2 {{ $t('Dashboard.title05') }}
          p.none(v-if="!anyCountsOf.gender") {{ $t('Dashboard.none_data') }}
          Gender#genderGraph.fixed(v-on:counts-updated="onCountsUpdated('gender', $event)")
        el-col.graph(:span="12")
          h2 {{ $t('Dashboard.title06') }}
          p.noneAge(:class="this.$i18n.locale" v-if="!anyCountsOf.age") {{ $t('Dashboard.none_data') }}
          Age#ageGraph.fixed(v-on:counts-updated="onCountsUpdated('age', $event)")

  el-row(type="flex" justify="space-between")
    el-col#device(:span="12" v-intro="$t('Guide.dashboard_guide03')")
      h1 {{ $t('Dashboard.title03') }}
      p {{ $t('Dashboard.description03') }}
      Device(ref="device")

    el-col#event(:span="12" v-intro="$t('Guide.dashboard_guide04')")
      h1 {{ $t('Dashboard.title04') }}
      p {{ $t('Dashboard.description04') }}
      Event(ref="event")

</template>

<script>
import Visited from './Visited'
import Gender from './Gender'
import Age from './Age'
import Device from './Device'
import Event from './Event'
import moment from 'moment'

export default {
  name: 'Dashboard',
  title: 'Dashboard',
  components: { Visited, Gender, Age, Device, Event },
  data () {
    return {
      visitedLoading: null,
      anyCountsOf: {
        visited: false,
        gender: false,
        age: false
      },
      api: {
        count: 0,
        userAccessByGenderAndAge: { }
      },
      ages: [{
        label: this.$t('Analysis.User.age10'),
        value: 'from10to19'
      },{
        label: this.$t('Analysis.User.age20'),
        value: 'from20to29'
      },{
        label: this.$t('Analysis.User.age30'),
        value: 'from30to39'
      },{
        label: this.$t('Analysis.User.age40'),
        value: 'from40to49'
      },{
        label: this.$t('Analysis.User.age50'),
        value: 'from50to59'
      },{
        label: this.$t('Analysis.User.age60'),
        value: 'from60to69'
      },{
        label: this.$t('Analysis.User.age70'),
        value: 'over70'
      }],
    }
  },
  mounted() {
    const date = moment().format('YYYY-MM-DD')
    this.getDeviceLogs(date)
    this.getEventLogs(date)
    this.visitedLoading = this.makeLoading("visitedGraph")
    
    // 最初のチュートリアル表示
    if (this.$store.state.global.intro == false){
      setTimeout(this.startGuide, 5000)
    }
  },
  methods: {

    startGuide: function () {
      const introJs = require('intro.js/intro.js'),
            intro = introJs()
      intro.start()

      const that = this
      intro.onexit(function(){
        that.$store.dispatch('setIntro', true)
      })
    },
    
    // 部分ローディングを生成
    makeLoading: function(name){
      return this.$loading({
        target: document.getElementById(name),
        fullscreen: false,
        background: 'rgba(255, 255, 255, 0.8)'
      })
    },

    // デバイスに紐づくログを取得
    getDeviceLogs: function (date = null){
      return this.$store.dispatch('getDeviceLogs', date)
        .then(() => {
          this.$refs.device.isLoading = false
        }).catch((e) => {
        })
    },

    // イベントに紐づくログを取得
    getEventLogs: function (date = null){
      return this.$store.dispatch('getEventLogs', date)
        .then(() => {
          this.$refs.event.isLoading = false
        }).catch((e) => {
        })
    },
    onCountsUpdated(graph, anyExist ) {
      if (graph === 'visited' && this.visitedLoading) {
        this.visitedLoading.close();
      }
      this.anyCountsOf[graph] = anyExist;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

#dashboard {
  padding: 40px 40px 0 40px;
}
.el-row {
  margin-bottom: 20px;
  height: max-content;

  &:last-child {
    margin-bottom: 10px;
  }

  &.graph {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 6px;
  border: 1px solid $border;
  background: #FFF;
  margin-right: 20px;
  padding: 20px;
  min-width: 525px;
  min-height: 330px;

  &.graph {
    border: none;
    min-width: 230px;
    min-height: 150px;
    height: 230px;
    padding: 0 20px;
    margin-right: 0;

    &:first-child {
      padding-left: 10px;
    }
  }

  &:last-child{
    margin-right: 0;
  }

  .fixed {
    min-width: 230px;
    min-height: 230px;
    max-width: 230px;
    max-height: 230px;
    text-align: center;
  }

  h1 {
    margin: 0 0 3px 0;
    font-size: 18px;
    font-weight: normal;
  }
  p {
    font-size: 12px;
    color: #999;
    margin: 0 0 15px 0;

    &.none {
      position: relative;
      margin: 90px 0 -110px 0;
      text-align: center;
    }
    &.noneAge {
      position: relative;
      width: 150px;
      margin: 80px 0 -125px 67px;
      padding: 0 20px 0 10px;
      text-align: center;

      &.en {
        width: 140px;
        margin: 80px 0 -125px 90px;
      }
    }
    &.noneVisited {
      position: absolute;
      margin: 90px 0 0 180px;
    }
  }

  h2 {
    font-size: 13px;
    font-weight: 500;
    margin: 0;
  }
}
</style>

